export enum CashupConfigurationGroupEnum {
  setting = "Setting",
  standalone = "Standalone",
}
